import React, { Fragment } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useRef } from "react";
import { useLocation } from "react-router-dom/dist";

import {
  useVisaTypeUpdate,
  useCreateVisaType,
  useGetVisaTypeDetail,
} from "../../actions/visatype-action";
import { useState } from "react";
import { useEffect } from "react";
import Card from "react-bootstrap/Card";
import Spinner from "react-bootstrap/Spinner";
import PageTitle from "../layouts/PageTitle";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TostifyConfig } from "../../utils/Constance";
import LoadingOverlay from 'react-loading-overlay';

function AddVisaType() {
  const navigate = useNavigate();

  const FormRef = useRef(null);

  const location = useLocation();
  let id = location?.state?.rowId;

  const [visatype, setvisatype] = useState({
    visa_type: "",
    code: "",
  });

  const handleChange = (e) => {
    setvisatype((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const { data: visatypeDetail, isLoading: loadingVisaTypeFn } = useGetVisaTypeDetail(
    location?.state?.rowId
  );

  const { mutate: postNewVisaType, isLoading: loadingpostNewVisaTypeFn } =
    useCreateVisaType();
  const { mutate: patchVisaType, isLoading: loadingpatchVisaTypeInfoFn } =
    useVisaTypeUpdate();

  useEffect(() => {
    if (location?.state?.rowId) {
      setvisatype(visatypeDetail);
    }
  }, [visatypeDetail]);

  const handleSubmit = () => {
    let FormValidity = FormRef.current.reportValidity();
    if (FormValidity === true && location?.state?.rowId) {

      try {
        patchVisaType(
          { id, visatype },
          {
            onSuccess: (response) => {
              toast.success("Visa Type  Updated", TostifyConfig);
              navigate("/list-visatype/");
            },
          }
        );
      } catch (error) {
        console.error(error);
      }
    } else if (FormValidity === true) {
      try {
        postNewVisaType(visatype, {
          onSuccess: (response) => {
            toast.success("Visa Type  Added", TostifyConfig);
            navigate("/list-visatype/");
          },
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <Fragment>
      <PageTitle activeMenu="Settings" motherMenu="Home" />
      <div>
        <div className="col-xl-12 col-xxl-12">
          <Card className="az-card">
            <Card.Header>
              <h3>{id ? "Edit VisaType" : "New VisaType"}</h3>
            </Card.Header>
            <LoadingOverlay
              active={loadingVisaTypeFn && id}
              spinner
              text='Fetching...'
              className="custom-overlay"
            >
              <Card.Body>
                <form ref={FormRef}>
                  <Form.Group className="mb-3">
                    <Row>
                      <Col className="col-lg-6 mb-2">
                        <label className="text-label">
                          Visa Type<span className="required">*</span>
                        </label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="visa_type"
                          value={visatype?.visa_type}
                          onChange={(e) => handleChange(e)}
                          required
                        />
                      </Col>
                      <Col className="col-lg-6 mb-2">
                        <label className="text-label">
                          Visa code
                        </label>
                        <Form.Control
                          type="text"
                          placeholder="Type Text"
                          name="code"
                          value={visatype?.code}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className="mt-2">
                    <Row>
                      <Col className="col-md-12">
                        <hr />
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Button
                            variant="danger light btn-sm"
                            onClick={() => {
                              navigate("/list-visatype");
                            }}
                          >
                            Cancel
                          </Button>
                          &nbsp;&nbsp;



                          <Button variant="primary btn-sm"
                            disabled={loadingVisaTypeFn && id || loadingpostNewVisaTypeFn || loadingpatchVisaTypeInfoFn}
                            onClick={handleSubmit}
                          >
                            {loadingpostNewVisaTypeFn ||
                              loadingpatchVisaTypeInfoFn ? (
                              <>
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="me-2"
                                />
                                Loading...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form.Group>
                </form>
              </Card.Body>
            </LoadingOverlay>
          </Card>
        </div>
      </div>
    </Fragment>
  );
}

export default AddVisaType;
